import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {
	Box,
	Button,
	Checkbox,
	FormControl,
	FormControlLabel,
	Grid,
	InputLabel,
	ListItemText,
	MenuItem,
	OutlinedInput,
	Radio,
	RadioGroup,
	Select,
	TextField,
	Tooltip,
	Typography,
} from '@mui/material';
import { ItemText, setColorStyle, SubtitleItemText } from './BiasInfo';
import {
	getFullName,
	handleError,
	handleSuccess,
	whichDivison,
} from '../../../helpers/utils';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { es } from 'date-fns/locale';
import { SearchAppBar } from './BiasInfoAppBar';
import { getOrderInfo, registerSubOrder } from '../../../actions/orders';
import { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { getSortedBiases } from '../../../actions/biases';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import { TextFieldComponent } from '../../orders/NewOrderForm2';
import {
	format2Date,
	getTodayDate,
	getTodayDateTime,
} from '../../../helpers/hours';
import { getClientAddress } from '../../../actions/client';
import { generateIncidentReport } from '../../../actions/pdf';
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export const OrderIncidence = ({ open, handleClose, orderId = null }) => {
	const classes = useStyles();

	// Order
	const [order, setOrder] = useState(null);
	// Part type
	const [partArray, setPartArray] = useState([]);
	const [biasesArray, setBiasesArray] = useState([]);
	const [loading, setLoading] = useState(true);
	const [newSubOrder, setNewSubOrder] = useState({ data: null, path: '' });
	const [deliveryDate, setDeliveryDate] = useState(null);
	const [incidenceType, setIncidenceType] = useState(null);

	// Store: user
	const { user = null } = useSelector((state) => state);

	// Navigation
	const navigate = useNavigate();

	// Generate rows by array
	const generateRows = async () => {
		// New biases
		let newBiases = [];

		const { data } = await getSortedBiases(
			orderId,
			'original',
			user.area?.name
		);
		newBiases = data.results;

		if (newBiases?.length === 0) {
			setBiasesArray([]);
		} else {
			const res = newBiases.map((item, index) => {
				const row = {
					// ...item,
					id: item.id,
					description: item.description,
					key: item.key,
				};

				return row;
			});
			setBiasesArray(res || []);
		}

		setLoading(false);
	};

	useEffect(() => {
		generateRows();
		getOrderInfo(orderId).then(({ data }) => {
			setOrder(data);
		});
	}, []);

	const handleChangeSelect = (event) => {
		const {
			target: { value },
		} = event;

		const selectedItems =
			typeof value === 'string' ? value.split(',') : value;

		// Obtain the complete object
		const selectedObjects = biasesArray.filter((item) =>
			selectedItems.includes(item.description)
		);

		setPartArray(selectedObjects);
	};

	const handleReset = () => {
		setPartArray([]);
		setBiasesArray([]);
		setIncidenceType(null);
		setDeliveryDate(null);
	};

	const handleGenerateIncidentPDF = () => {
		// Create incident PDF payload
		const pdfPayload = {
			number_order: order?.number_order,
			datetime: getTodayDateTime(),
			request_date: format2Date(getTodayDate(), 'DD/MM/YYYY'),
			delivery_date: format2Date(deliveryDate, 'DD/MM/YYYY'),
			incident_number: newSubOrder?.data?.key,
			division: whichDivison(order?.division),
			manager: getFullName(user),
			client: order.client_id.company_name,
			type: incidenceType,
			client_address: getClientAddress(order?.client_id),
			biases: partArray,
		};
		// Generate PDF and download it
		generateIncidentReport(pdfPayload).finally(() => {
			// Reset form
			handleReset();
		});
	};

	// Go to the new suborder info detail
	const handleGoToNewSuborder = () => {
		navigate(newSubOrder.path);
		handleReset();
		handleClose();
	};

	// Go to the orders table
	const handleGoToOrdersTable = () => navigate(`/dashboard/ordenes`);

	// Handle submit form
	const handleSubmit = () => {
		registerSubOrder({
			existing_order_id: order?.id,
			bias_ids: partArray?.map(({ id }) => id),
			delivery_date: format2Date(deliveryDate),
		})
			.then(({ data }) => {
				handleSuccess('Incidencia creada');
				// Set new suborder data
				setNewSubOrder({
					data: data?.ok ? data : false,
					path: `/dashboard/order/${data?.id}`,
				});
			})
			.catch((error) => {
				handleError(
					error,
					'Ocurrió un error al intentar crear la suborder'
				);
			});
	};

	const handleRadioChange = (event) => {
		setIncidenceType(event.target.value);
	};

	const handleTextFieldChange = (index) => (event) => {
		const { value } = event.target;
		setPartArray((prevArray) => {
			const newArray = [...prevArray];
			newArray[index] = {
				...newArray[index],
				incident_description: value,
			};
			return newArray;
		});
	};

	const isButtonDisabled = () => {
		// Verify if partArray is not empty
		const hasItemsInArray = partArray.length > 0;

		// Check if every element in partArray has an incident_description
		const allDescriptionsFilled = partArray.every(
			(item) =>
				item.incident_description &&
				item.incident_description.trim().length > 0
		);

		// Verify if incidenceType is not empty
		const hasIncidenceType =
			incidenceType && incidenceType.trim().length > 0;

		return !(
			hasItemsInArray &&
			allDescriptionsFilled &&
			hasIncidenceType &&
			deliveryDate
		);
	};

	// Button style
	const ButtonStyle = { marginLeft: '15px' };

	return (
		<div>
			{/* Dialog data */}
			{order && (
				<Dialog
					fullScreen
					open={open}
					onClose={handleClose}
					TransitionComponent={Transition}
				>
					{/* Content */}
					<Box sx={{ flexGrow: 1 }}>
						<SearchAppBar
							title={`No. de pedido: ${order?.number_order}`}
							handleClose={handleClose}
						/>
						{newSubOrder?.data ? (
							<div style={{ margin: '25%', textAlign: 'center' }}>
								<h2>
									Suborden creada correctamente:{' '}
									{newSubOrder?.data?.key}
								</h2>
								<br />
								<div>
									<Button
										color='success'
										variant='outlined'
										onClick={handleGenerateIncidentPDF}
										style={ButtonStyle}
									>
										Descargar PDF
									</Button>
									<Button
										color='primary'
										variant='outlined'
										onClick={handleGoToNewSuborder}
										style={ButtonStyle}
									>
										Ir a la suborden
									</Button>
									<Button
										color='secondary'
										variant='outlined'
										onClick={handleGoToOrdersTable}
										style={ButtonStyle}
									>
										Ir a los pedidos
									</Button>
									<Button
										color='error'
										variant='outlined'
										onClick={handleClose}
										style={ButtonStyle}
									>
										Cerrar
									</Button>
								</div>
							</div>
						) : (
							<div style={{ padding: '20px' }}>
								{/* Information */}
								<SubtitleItemText
									title='Formato de incidencia '
									first
								/>
								<Grid
									container
									style={{
										...setColorStyle('black'),
										padding: '20px 20px 0 20px',
									}}
								>
									{/* Division */}
									<Grid item xs={3}>
										<ItemText
											subtitle='División'
											text={whichDivison(order?.division)}
										/>
									</Grid>
									{/* No. Pedido */}
									<Grid item xs={3}>
										<ItemText
											subtitle='No. de pedido'
											text={order?.number_order}
										/>
									</Grid>
									{/* Client name */}
									<Grid item xs={3}>
										<ItemText
											subtitle='Nombre del cliente'
											text={
												order?.client_id?.company_name
											}
										/>
									</Grid>
									{/* Asesor */}
									<Grid item xs={3}>
										<ItemText
											subtitle='Asesor'
											text={getFullName(user)}
										/>
									</Grid>
									{/* New delivery date */}
									<Grid item xs={2}>
										<ItemText subtitle='Fecha de entrega' />
										<LocalizationProvider
											dateAdapter={AdapterDateFns}
											adapterLocale={es}
											utils={DateFnsUtils}
										>
											<DesktopDatePicker
												fullWidth
												label='Fecha de entrega'
												inputFormat='dd/MM/yyyy'
												disablePast={true}
												name='deliveryDate'
												value={deliveryDate}
												onChange={(val) =>
													setDeliveryDate(val)
												}
												renderInput={(params) =>
													TextFieldComponent(
														params,
														'Fecha de entrega',
														true
													)
												}
											/>
										</LocalizationProvider>
									</Grid>
									{/* Incident checkbox group */}
									<Grid
										item
										xs={9}
										style={{
											margin: '0 0 0 20px',
											width: '85%',
										}}
									>
										<ItemText subtitle='Tipo de Incidencia' />
										<FormControl
											component='fieldset'
											fullWidth
										>
											<RadioGroup
												className={
													classes.horizontalFormGroup
												}
												aria-label='position'
												row
												value={incidenceType}
												onChange={handleRadioChange}
												style={{
													margin: '10px 0 0 0',
												}}
											>
												<FormControlLabel
													value='Reposición'
													control={<Radio />}
													label={
														<Typography
															className={
																classes.formControlLabel
															}
														>
															Reposición
														</Typography>
													}
													labelPlacement='end'
													style={{ fontSize: '19px' }}
												/>
												<FormControlLabel
													value='Reparación'
													control={<Radio />}
													label={
														<Typography
															className={
																classes.formControlLabel
															}
														>
															Reparación
														</Typography>
													}
													labelPlacement='end'
												/>
												<FormControlLabel
													value='Devolución'
													control={<Radio />}
													label={
														<Typography
															className={
																classes.formControlLabel
															}
														>
															Devolución
														</Typography>
													}
													labelPlacement='end'
												/>
												<FormControlLabel
													value='Faltantes'
													control={<Radio />}
													label={
														<Typography
															className={
																classes.formControlLabel
															}
														>
															Faltantes
														</Typography>
													}
													labelPlacement='end'
												/>
											</RadioGroup>
										</FormControl>
									</Grid>
									{/* Description */}
									<Grid item xs={6}>
										<ItemText subtitle='Descripcion de la incidencia' />
										<FormControl
											sx={{
												width: '100%',
												margin: '15px 0 0 0',
											}}
										>
											<InputLabel>Partida</InputLabel>
											<Select
												labelId='incidence-multiple-checkbox-label'
												id='incidence-multiple-checkbox'
												multiple
												value={partArray.map(
													(item) => item.description
												)}
												onChange={handleChangeSelect}
												input={
													<OutlinedInput label='Partida' />
												}
												renderValue={(selected) =>
													selected.join(', ')
												}
											>
												{biasesArray.map((item) => (
													<MenuItem
														key={item.description}
														value={item.description}
													>
														<Checkbox
															checked={partArray.some(
																(
																	selectedItem
																) =>
																	selectedItem.description ===
																	item.description
															)}
														/>
														<Tooltip
															arrow
															title={
																item.description
															}
														>
															<ListItemText
																key={
																	item.description
																}
																primary={
																	item.description
																}
															/>
														</Tooltip>
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Grid>
									{/* Textfield of description */}
									{partArray &&
										partArray.map((item, index) => (
											<Grid
												key={index}
												item
												xs={12}
												mt={1}
											>
												<ItemText
													text={`${item.description.slice(
														0,
														11
													)}`}
												/>
												<TextField
													fullWidth
													multiline
													minRows={4}
													helperText={`${item.description}`}
													value={
														item.incident_description ||
														''
													}
													onChange={handleTextFieldChange(
														index
													)}
												></TextField>
											</Grid>
										))}

									<Grid item xs={12} mt={1}>
										<Grid
											container
											direction='row'
											display='flex'
											justifyContent='end'
											alignItems='center'
											spacing={1}
										>
											<Grid item xs={4}>
												<LoadingButton
													fullWidth
													size='large'
													type='submit'
													style={{
														margin: '15px 0 0 0',
													}}
													variant='contained'
													loading={loading}
													className={classes.button}
													classes={{
														disabled:
															classes.disabledButton,
													}}
													onClick={handleSubmit}
													disabled={isButtonDisabled()}
												>
													Crear
												</LoadingButton>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</div>
						)}
					</Box>
				</Dialog>
			)}
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
	horizontalFormGroup: {
		display: 'flex',
		justifyContent: 'space-between', // Adjust space between elements
		width: '100%',
		padding: '10px',
	},
	formControlLabel: {
		fontSize: '19px',
	},
	button: {
		backgroundColor: '#143f6c',
		'&:hover': {
			backgroundColor: '#0f345c',
		},
	},
	disabledButton: {
		backgroundColor: '#d3d3d3',
	},
}));
